import { createSlice } from "@reduxjs/toolkit";

// Load initial state from session storage
const loadStateFromSessionStorage = () => {
  try {
    const serializedState = sessionStorage.getItem("fastEntryInvoices");
    if (serializedState === null) {
      return {
        invoices: [{
          id: Date.now(),
          items: [],
          invoiceNumber: "",
          selected: true
        }]
      };
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error("Error loading state from session storage:", err);
    return {
      invoices: [{
        id: Date.now(),
        items: [],
        invoiceNumber: "",
        selected: true
      }]
    };
  }
};

const initialState = loadStateFromSessionStorage();

const fastEntrySlice = createSlice({
  name: "fastEntry",
  initialState,
  reducers: {
    addInvoice: (state) => {
      const newInvoice = {
        id: Date.now(),
        items: [],
        invoiceNumber: "",
        selected: true
      };
      state.invoices.push(newInvoice);
      
      // Save to session storage
      try {
        sessionStorage.setItem("fastEntryInvoices", JSON.stringify(state));
      } catch (err) {
        console.error("Error saving to session storage:", err);
      }
    },
    // Expects payload: { id: number, allowDeleteAll?: boolean }
    deleteInvoice: (state, action) => {
      const { id, allowDeleteAll } = action.payload;
      // Allow override for deleting all invoices
      if (!allowDeleteAll && state.invoices.length <= 1) {
        return;
      }
      state.invoices = state.invoices.filter(invoice => invoice.id !== id);
      
      // Save to session storage
      try {
        sessionStorage.setItem("fastEntryInvoices", JSON.stringify(state));
      } catch (err) {
        console.error("Error saving to session storage:", err);
      }
    },
    updateInvoice: (state, action) => {
      const { invoiceId, updatedData } = action.payload;
      state.invoices = state.invoices.map(invoice => 
        invoice.id === invoiceId ? { ...invoice, ...updatedData } : invoice
      );
      
      // Save to session storage
      try {
        sessionStorage.setItem("fastEntryInvoices", JSON.stringify(state));
      } catch (err) {
        console.error("Error saving to session storage:", err);
      }
    },
    resetInvoices: (state) => {
      state.invoices = [{
        id: Date.now(),
        items: [],
        invoiceNumber: "",
        selected: true
      }];
      
      // Save to session storage
      try {
        sessionStorage.setItem("fastEntryInvoices", JSON.stringify(state));
      } catch (err) {
        console.error("Error saving to session storage:", err);
      }
    },
    clearInvoices: (state) => {
      state.invoices = []; // Completely clear the invoices array
      
      // Save to session storage
      try {
        sessionStorage.setItem("fastEntryInvoices", JSON.stringify(state));
      } catch (err) {
        console.error("Error saving to session storage:", err);
      }
    },
    toggleInvoiceSelected: (state, action) => {
      const invoiceId = action.payload;
      state.invoices = state.invoices.map(invoice =>
        invoice.id === invoiceId
          ? { ...invoice, selected: !invoice.selected }
          : invoice
      );
      try {
        sessionStorage.setItem("fastEntryInvoices", JSON.stringify(state));
      } catch (err) {
        console.error("Error saving to session storage:", err);
      }
    }
  }
});

export const { 
  addInvoice,
  deleteInvoice,
  updateInvoice,
  resetInvoices,
  clearInvoices,
  toggleInvoiceSelected
} = fastEntrySlice.actions;

export default fastEntrySlice.reducer;